<h1 mat-dialog-title>

    <b> Datos Préstamo para confirmar Codeudor</b></h1>
<br/>
<form #prestamoValidaForm=ngForm>

    <dialog-content>
        <p>
            <form-field appearance="outline" class="mat-input">
                <mat-label> Solicitante </mat-label>

                <mat-option>{{data.rutUsuario}} {{data.nombreUsuario}} {{data.apellidoUsuario}}</mat-option>

            </form-field>
        </p>
        <p>
            <form-field appearance="outline" class="mat-input">
                <mat-label> Monto Solicitado </mat-label>

                <mat-option> {{data.montoSolicitado}} </mat-option>

            </form-field>
        </p>
        <p>
            <form-field appearance="outline" class="mat-input">
                <mat-label> Cantidad Cuotas </mat-label>
                <mat-option> {{data.idCantidadCuota}} </mat-option>

            </form-field>
        </p>

      

        <p *ngIf="data.mostrarEditar == true">
            <form-field appearance="outline" class="mat-input">
                <mat-label> Adjuntar Cédula de Identidad (FRONTAL) </mat-label>
                <div class="col-lg-6">
                    <input #archivo [(ngModel)]="prestamo.archivoTest" type="file" class="form-control-file" name="archivo" (change)="seleccionaArchivo($event,1)" required accept="application/pdf, image/jpeg, image/jpg, image/png">
                </div>
            </form-field>
        </p>

        <p *ngIf="data.mostrarEditar == true">
            <form-field appearance="outline" class="mat-input">
                <mat-label> Adjuntar Cédula de Identidad (POSTERIOR) </mat-label>
                <div class="col-lg-6">
                    <input  #archivo2 type="file" [(ngModel)]="prestamo.archivoTest2" class="form-control-file" name="archivo2" (change)="seleccionaArchivo($event, 2)" required accept="application/pdf, image/jpeg, image/jpg, image/png">
                </div>
            </form-field>
        </p>


    </dialog-content>
</form>
<br/>
<mat-dialog-actions>
    <div *ngIf="data.mostrarEditar == false">

        <button mat-button class="mat-raised-button btn-dark" (click)="onCancelarClick()">
            <i class = "fa fa-trash"> </i> Salir
        </button>

    </div>
    <div *ngIf="data.mostrarEditar == true ">
        <button mat-button class="mat-raised-button btn-success" (click)="onAceptarClick()">
            <i class ="fa fa-check"> </i> Aceptar
        </button>
        <button mat-button class="mat-raised-button btn-danger" (click)="onRechazarClick()">
            <i class ="fa fa-times"> </i> Rechazar
        </button>
        <button mat-button class="mat-raised-button btn-dark" (click)="onCancelarClick()">
            <i class = "fa fa-trash"> </i> Salir
        </button>
    </div>

</mat-dialog-actions>